import React, { Component } from 'react';
import { Modal, Table } from 'react-bootstrap';
import { translate } from 'react-i18next';
import FlatButton from 'material-ui/FlatButton';
import swal from 'sweetalert';
import moment from 'moment';

var Config = require('../../../../config');

class ModalTraceability extends Component{
	constructor(props){
		super(props);
	
		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);

		this.state = {
			show: false,
			list:[]
		}
	}

	componentDidMount(){
		this.props.onRef(this);
	}

	handleShow(id){
		this.props.waiting.handleShow('Cargando...');
		fetch(Config.default.apiGateway.URL+'petitions/traceability/'+id, {
			method : 'get',
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
				'Accept' 		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(error) {
                swal('¡Error', error, 'error');
              });
	        }
	    }).then(response =>{
			this.setState({list: response, show:true});
			
		});
		
	}

	handleClose(){
		this.setState({	show: false, list:[]});
	}

	
	render(){
		const { t } = this.props;
		return(
			<div>
			<Modal bsSize={"lg"} show={this.state.show} onHide={this.handleClose}>
		       	<Modal.Header closeButton>
		        	<Modal.Title>Trazabilidad de muestra</Modal.Title>
		        </Modal.Header>
		        <Modal.Body >
		        	<div className="row" style={{paddingLeft:"10px",paddingRight:"10px"}}>
		        		<div className="col-xs-12">
		        			<Table responsive hover>
		        				<thead>
		        					<tr>
		        						<th>Fecha/Hr.</th>
		        						<th>Acción</th>
		        						<th>Usuario</th>
		        					</tr>
		        				</thead>
		        				<tbody >
		        					{this.state.list.map((l, i)=>(
		        						<tr key={i}>
		        							<td>{moment(l.timestamp).format('DD/MM/YYYY HH:mm')}</td>
		        							<td>{l.action}</td>
		        							<td>{l.user}</td>
		        						</tr>
		        					))}
		        				</tbody>
		        			</Table>
		        		</div>
				    </div>
		        </Modal.Body>
		        <Modal.Footer>
		        	<FlatButton primary={true} label={t('content.generics.buttons.close')}  onClick={this.handleClose}/>
		        </Modal.Footer>
	      	</Modal>
	      	</div>
		);
	}

}

export default translate('translations') (ModalTraceability)